<template>
  <div class="wrapper">
    <!-- Left Panel -->
    <div class="left">
      <div class="noise"></div>
      <div class="left-top">
        <div class="brand">
          <div class="brand-mark">VS</div>
          <div class="brand-label">
            <span class="brand-name">VSTECS</span>
            <span class="brand-sub">Cloud</span>
          </div>
        </div>
      </div>
      <div class="left-center">
        <h1 class="hero-title">智能账单管理平台</h1>
        <p class="hero-desc">一站式多云账单处理、成本分析与费用优化</p>
        <div class="features">
          <div class="feat">
            <div class="feat-icon">
              <svg viewBox="0 0 24 24"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
            </div>
            <div class="feat-body"><h4>多账户统一管理</h4><p>跨组织多账户集中管控与权限分配</p></div>
          </div>
          <div class="feat">
            <div class="feat-icon">
              <svg viewBox="0 0 24 24"><path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
            </div>
            <div class="feat-body"><h4>自动化账单处理</h4><p>账单自动采集、智能解析与归档对账</p></div>
          </div>
          <div class="feat">
            <div class="feat-icon">
              <svg viewBox="0 0 24 24"><line x1="12" y1="20" x2="12" y2="10"/><line x1="18" y1="20" x2="18" y2="4"/><line x1="6" y1="20" x2="6" y2="16"/></svg>
            </div>
            <div class="feat-body"><h4>实时成本分析</h4><p>覆盖率追踪、费用预警与优化建议</p></div>
          </div>
        </div>
      </div>
      <div class="left-bottom"><p>&copy; 2026 VSTECS Technology International</p></div>
    </div>
    <!-- Right Panel -->
    <div class="right">
      <div class="form-wrap">
        <div class="form-logo"><img src="../assets/logo.png" alt="VSTECS" /></div>
        <p class="form-subtitle">登录您的账户以继续</p>
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="0" class="login-form" @keyup.enter="submitForm('ruleForm')">
          <div class="field">
            <label class="field-label">账号</label>
            <el-form-item prop="username">
              <el-input v-model.trim="ruleForm.username" placeholder="请输入账号" maxlength="60" class="login-input" />
            </el-form-item>
          </div>
          <div class="field">
            <label class="field-label">密码</label>
            <el-form-item prop="password">
              <el-input v-model.trim="ruleForm.password" type="password" show-password placeholder="请输入密码" maxlength="60" class="login-input" />
            </el-form-item>
          </div>
          <div class="field">
            <label class="field-label">验证码</label>
            <el-form-item prop="captcha">
              <div class="captcha-group">
                <el-input v-model.trim="ruleForm.captcha" placeholder="请输入验证码" maxlength="10" class="login-input captcha-input" />
                <img class="captcha-img" :src="image_base" @click="getCaptcha" title="点击刷新" />
              </div>
            </el-form-item>
            <button type="button" class="captcha-refresh" @click="getCaptcha">看不清？换一个</button>
          </div>
          <div class="options"><el-checkbox v-model="rememberpassword">记住密码</el-checkbox></div>
          <el-button type="primary" :loading="loadingLg" class="btn-primary" @click="submitForm('ruleForm')">{{ loginName }}</el-button>
          <div class="sep"><span>或</span></div>
          <button type="button" class="btn-link" @click="testLogin()">测试账号登录</button>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import {login,apiSystemWebRouter,getCaptcha,apiSystemUser,getLinkerList,getBillWarning} from '@/api/api'
import {delCookie, getCookie, setCookie} from '@/utils/util'
import {useMutitabsStore} from "@/store/mutitabs"
import {useSiteThemeStore} from "@/store/siteTheme"
import {setStorage} from '@/utils/util'
import i18n from '@/locales'
import md5 from 'js-md5'
import {apiSystemUser as apiSysUser} from '@/api/api'

export default {
  name: 'login',
  setup() {
    const mutitabsstore = useMutitabsStore()
    const siteThemeStore = useSiteThemeStore()
    const { t } = i18n.global
    return { mutitabsstore, siteThemeStore, t }
  },
  data() {
    return {
      loadingLg: false,
      rememberpassword: false,
      ruleForm: {
        username: '',
        password: '',
        captcha: '',
        captchaKey: null,
      },
      rules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        captcha: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      },
      image_base: null,
      allmenu: [],
      curRole: 'superadmin',
      loginName: '登录',
    }
  },
  created() {
    this.getuserpassword()
    this.getCaptcha()
  },
  methods: {
    getuserpassword() {
      if (getCookie('username') != '' && getCookie('password') != '') {
        this.ruleForm.username = getCookie('username')
        this.ruleForm.password = getCookie('password')
        this.rememberpassword = true
      }
    },
    getCaptcha() {
      getCaptcha().then((ret) => {
        this.ruleForm.captcha = null
        this.ruleForm.captchaKey = ret.data.data.key
        this.image_base = ret.data.data.image_base
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loadingLg = true
          var passwd = this.ruleForm.password
          this.ruleForm.password = md5(this.ruleForm.password)
          login(this.ruleForm).then(async res => {
            if (res.code === 2000) {
              this.loginName = '登录中···'
              if (this.rememberpassword) {
                await setCookie('username', this.ruleForm.username, 7)
                await setCookie('password', passwd, 7)
              } else {
                await delCookie('username')
                await delCookie('password')
              }
              this.mutitabsstore.setLogintoken(res.data.access)
              this.mutitabsstore.setUserName(res.data.username)
              this.mutitabsstore.setUserId(res.data.userId)
              this.mutitabsstore.setRefresh(res.data.refresh)
              localStorage.setItem('userInfo', JSON.stringify({
                userId: res.data.userId, name: res.data.name,
                type: res.data.type || res.data.user_type
              }))
              if (res.data.rolekey) { localStorage.setItem('curRole', res.data.rolekey); this.curRole = res.data.rolekey }
              if (res.data.account) { localStorage.setItem('account', res.data.account) }
              await this.getUserList()
              this.loadingLg = false
              this.loginName = '登录成功'
              this.getMenu()
            } else {
              this.getCaptcha()
              this.loadingLg = false
              this.$message.error(JSON.stringify(res.msg))
            }
          })
        } else {
          this.$message.error('请输入用户名密码/验证码！')
        }
      })
    },
    testLogin() {
      this.ruleForm.username = 'test-999'
      this.ruleForm.password = 'test-999'
    },
    getUserList() {
      const userId = localStorage.getItem('userId')
      return apiSystemUser({ id: userId, page: 1, limit: 1 }).then(async (res) => {
        if (res.code == 2000) {
          res.data.data.forEach(el => {
            if (el.id == userId) {
              localStorage.setItem('curRole', el.rolekey[0])
              this.curRole = el.rolekey[0]
              localStorage.setItem('account', el.account)
            }
          })
          await this.getLinkersList()
          await this.getWarningList()
        }
      })
    },
    async getLinkersList() {
      var data = { page: 1, limit: 999999 }
      if (this.curRole == 'sales') { data.sales = localStorage.getItem('account') }
      await getLinkerList(data).then(res => {
        if (res.code == 2000 && res.data && res.data.data) {
          var len = res.data.data.filter(el => el.status == 0)
          localStorage.setItem('unCreatedLinkers', JSON.stringify(len))
          localStorage.setItem('len', len.length)
        } else {
          localStorage.setItem('unCreatedLinkers', JSON.stringify([]))
          localStorage.setItem('len', 0)
        }
      })
    },
    async getWarningList() {
      await getBillWarning({ page: 1, limit: 999999 }).then(res => {
        if (res.code == 2000) { localStorage.setItem('warningList', JSON.stringify(res.data)) }
      })
    },
    getMenu() {
      this.allmenu = []
      this.loadingLg = true
      apiSystemWebRouter().then(res => {
        if (res.code == 2000) {
          let menuTree = []
          if (res.data.data.length > 0) {
            let childrenList = res.data.data.filter(item => item.parent && item.visible == 1)
            let parentList = res.data.data.filter(item => !item.parent && item.visible == 1)
            if (parentList.length > 0) {
              parentList.forEach(item => {
                let menuTreeChildren = []
                let children = childrenList.filter(a => a.parent == item.id)
                let children2 = childrenList.filter(c => children.every(c1 => c.path != c1.path))
                children.forEach(itemb => {
                  let cmenuTreeChildren = []
                  children2.filter(c => c.parent == itemb.id).forEach(d => {
                    cmenuTreeChildren.push({ text: d.name, id: d.id, attributes: { url: d.web_path, icon: d.icon }, hasChildren: false, hasParent: true })
                  })
                  menuTreeChildren.push({ text: itemb.name, id: itemb.id, attributes: { url: itemb.web_path, icon: itemb.icon }, children: cmenuTreeChildren, hasChildren: cmenuTreeChildren.length > 0, hasParent: true })
                })
                menuTree.push({ text: item.name, id: item.id, attributes: { url: children.length > 0 ? children[0].web_path : item.web_path, icon: item.icon }, hasChildren: children.length > 0, hasParent: false, children: menuTreeChildren })
                item.children = [...children]
              })
            }
            let menuList = []
            res.data.data.forEach(item => { menuList.push({ url: item.web_path, moduleName: item.name, menuPermission: item.menuPermission }) })
            setStorage('menuList', JSON.stringify(menuList))
          }
          this.allmenu = menuTree
          if (this.allmenu.length > 0) {
            localStorage.setItem('showNotify', 1)
            this.$nextTick(() => {
              const curRole = localStorage.getItem('curRole')
              const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
              if (userInfo.type === 2 || curRole === 'agent') {
                this.$router.replace({ path: '/agentDashboard' })
              } else if (userInfo.type === 4 || curRole === 'customer') {
                this.$router.replace({ path: '/customerDashboard' })
              } else {
                this.$router.replace({ path: '/salesOverview' })
              }
            })
          } else {
            this.mutitabsstore.logout('false')
            this.$router.push({ path: '/login' })
            sessionStorage.clear(); localStorage.clear()
            this.loadingLg = false
            this.$message.warning('暂无授权任何菜单权限~')
          }
          setStorage('allmenu', JSON.stringify(this.allmenu))
          let tabsPage, TabsValue
          if (menuTree[0].hasChildren) {
            tabsPage = [{ title: menuTree[0].children[0].text, name: menuTree[0].children[0].attributes.url }]
            TabsValue = menuTree[0].children[0].attributes.url
          } else {
            tabsPage = [{ title: menuTree[0].text, name: menuTree[0].attributes.url }]
            TabsValue = menuTree[0].attributes.url
          }
          this.mutitabsstore.firstTabs([tabsPage, TabsValue])
          this.$forceUpdate()
        } else { this.$message.warning(res.msg) }
        this.loadingLg = false
      })
    },
  }
}
</script>

<style lang="scss" scoped>
$font: "Plus Jakarta Sans", -apple-system, BlinkMacSystemFont, "SF Pro Display", "PingFang SC", "Microsoft YaHei", sans-serif;
$bg-light: #f5f5f7;
$text-primary: #1d1d1f;
$text-secondary: #6e6e73;
$text-tertiary: #86868b;
$text-quaternary: #aeaeb2;
$border: #d2d2d7;
$accent: #0071e3;
$ring: rgba(0, 113, 227, 0.25);
$input-bg: rgba(255, 255, 255, 0.65);
$input-hover: rgba(255, 255, 255, 0.85);

.wrapper {
  display: flex; height: 100vh; font-family: $font;
  -webkit-font-smoothing: antialiased; font-feature-settings: "cv02","cv03","cv04","cv11";
  letter-spacing: -0.011em; overflow: hidden;
}
.left {
  flex: 0 0 38%; max-width: 38%; background: #0a0a0a; position: relative;
  display: flex; flex-direction: column; justify-content: space-between;
  padding: 44px 52px 44px 108px; overflow: hidden;
  &::before { content:''; position:absolute; width:600px; height:600px; top:-15%; right:-15%; background:radial-gradient(circle,rgba(0,113,227,0.07) 0%,transparent 65%); pointer-events:none; }
  &::after { content:''; position:absolute; width:500px; height:500px; bottom:-10%; left:-10%; background:radial-gradient(circle,rgba(88,86,214,0.05) 0%,transparent 65%); pointer-events:none; }
}
.noise { position:absolute; inset:0; background-image:url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.03'/%3E%3C/svg%3E"); pointer-events:none; opacity:0.5; }
.left-top { position:relative; z-index:1; }
.brand { display:flex; align-items:center; gap:10px; }
.brand-mark { width:32px; height:32px; border-radius:8px; background:$accent; display:flex; align-items:center; justify-content:center; font-size:11px; font-weight:700; color:#fff; letter-spacing:0.02em; }
.brand-label { display:flex; flex-direction:column; }
.brand-name { font-size:15px; font-weight:600; color:#fff; letter-spacing:-0.02em; line-height:1.2; }
.brand-sub { font-size:10px; font-weight:500; color:rgba(255,255,255,0.35); letter-spacing:0.12em; text-transform:uppercase; }
.left-center { position:relative; z-index:1; animation:slideUp 0.7s cubic-bezier(0.16,1,0.3,1) 0.1s both; }
.hero-title { font-size:30px; font-weight:700; color:#fff; letter-spacing:-0.03em; line-height:1.3; margin-bottom:14px; }
.hero-desc { font-size:16px; color:rgba(255,255,255,0.45); font-weight:400; line-height:1.7; max-width:380px; letter-spacing:-0.005em; }
.features { margin-top:52px; display:flex; flex-direction:column; gap:28px; }
.feat {
  display:flex; align-items:center; gap:16px;
  &:nth-child(1) { animation:slideUp 0.6s cubic-bezier(0.16,1,0.3,1) 0.25s both; }
  &:nth-child(2) { animation:slideUp 0.6s cubic-bezier(0.16,1,0.3,1) 0.35s both; }
  &:nth-child(3) { animation:slideUp 0.6s cubic-bezier(0.16,1,0.3,1) 0.45s both; }
}
.feat-icon {
  width:44px; height:44px; border-radius:12px; background:rgba(255,255,255,0.04);
  border:1px solid rgba(255,255,255,0.06); display:flex; align-items:center; justify-content:center; flex-shrink:0;
  svg { width:20px; height:20px; stroke:rgba(255,255,255,0.55); fill:none; stroke-width:1.5; stroke-linecap:round; stroke-linejoin:round; }
}
.feat-body {
  h4 { font-size:14px; font-weight:600; color:rgba(255,255,255,0.88); letter-spacing:-0.01em; margin-bottom:2px; }
  p { font-size:13px; color:rgba(255,255,255,0.35); font-weight:400; margin:0; }
}
.left-bottom { position:relative; z-index:1; p { font-size:11px; color:rgba(255,255,255,0.2); margin:0; } }

.right { flex:1; display:flex; align-items:center; justify-content:center; background:$bg-light; padding:48px; overflow-y:auto; }
.form-wrap { width:100%; max-width:420px; animation:slideUp 0.6s cubic-bezier(0.16,1,0.3,1) 0.15s both; }
.form-logo { text-align:center; margin-bottom:12px; img { height:54px; width:auto; object-fit:contain; } }
.form-subtitle { text-align:center; font-size:15px; color:$text-secondary; font-weight:400; margin-bottom:36px; letter-spacing:-0.01em; }

.login-form {
  :deep(.el-form-item) { margin-bottom:0; }
  :deep(.el-form-item__error) { padding-top:2px; font-size:11px; }
}
.field { margin-bottom:18px; }
.field-label { display:block; font-size:13px; font-weight:600; color:$text-primary; margin-bottom:7px; letter-spacing:-0.005em; }

.login-input {
  :deep(.el-input__wrapper) {
    width:100%; height:50px !important; padding:0 16px !important; font-size:15px;
    background:$input-bg !important; border:1.5px solid rgba(0,0,0,0.06) !important;
    border-radius:12px !important; box-shadow:none !important;
    backdrop-filter:blur(8px); -webkit-backdrop-filter:blur(8px);
    transition:all 0.25s cubic-bezier(0.25,0.46,0.45,0.94);
    &:hover { background:$input-hover !important; border-color:rgba(0,0,0,0.1) !important; }
    &.is-focus { background:#fff !important; border-color:$accent !important; box-shadow:0 0 0 4px $ring !important; }
  }
  :deep(.el-input__inner) {
    height:50px !important; line-height:50px !important; font-size:15px !important;
    font-family:$font; color:$text-primary; font-weight:400;
    &::placeholder { color:$text-quaternary; font-weight:400; }
  }
  :deep(.el-input__prefix) { display:none; }
  :deep(.el-input__suffix) { color:$text-tertiary; &:hover { color:$text-primary; } }
}

.captcha-group { display:flex; gap:12px; align-items:stretch; width:100%; }
.captcha-input { flex:1; }
.captcha-img { width:130px; height:50px; border-radius:12px; border:1px solid rgba(0,0,0,0.04); cursor:pointer; flex-shrink:0; object-fit:cover; background:#e5e5ea; transition:opacity 0.2s; &:hover { opacity:0.8; } }
.captcha-refresh { display:block; text-align:right; font-size:12px; color:$text-quaternary; margin-top:5px; cursor:pointer; background:none; border:none; font-family:$font; margin-left:auto; padding:0; transition:color 0.2s; &:hover { color:$accent; } }

.options {
  display:flex; align-items:center; margin:24px 0 30px;
  :deep(.el-checkbox__label) { font-size:13px; color:$text-secondary; font-weight:400; }
  :deep(.el-checkbox__inner) { width:17px; height:17px; border:1.5px solid $border; border-radius:5px; }
  :deep(.el-checkbox__input.is-checked .el-checkbox__inner) { background-color:$accent; border-color:$accent; }
}

.btn-primary {
  width:100%; height:52px !important; font-size:16px !important; font-weight:600 !important;
  color:#fff !important; background:$text-primary !important; border:none !important;
  border-radius:14px !important; letter-spacing:-0.01em;
  transition:all 0.3s cubic-bezier(0.25,0.46,0.45,0.94);
  &:hover { background:#2c2c2e !important; box-shadow:0 6px 24px rgba(0,0,0,0.12); transform:translateY(-1px); }
  &:active { transform:translateY(0); box-shadow:0 2px 8px rgba(0,0,0,0.1); }
}

.sep {
  display:flex; align-items:center; gap:16px; margin:22px 0;
  &::before, &::after { content:''; flex:1; height:0.5px; background:rgba(0,0,0,0.08); }
  span { font-size:12px; color:$text-quaternary; font-weight:400; }
}

.btn-link {
  width:100%; height:46px; font-size:14px; font-weight:500; font-family:$font;
  color:$accent; background:transparent; border:none; border-radius:12px; cursor:pointer;
  display:flex; align-items:center; justify-content:center; transition:background 0.2s;
  &:hover { background:rgba(0,113,227,0.06); }
}

@keyframes slideUp {
  from { opacity:0; transform:translateY(20px); }
  to { opacity:1; transform:translateY(0); }
}

@media (max-width:1024px) {
  .left { flex:0 0 34%; max-width:34%; padding:36px 40px 36px 80px; }
  .hero-title { font-size:30px; }
}
@media (max-width:768px) {
  .wrapper { flex-direction:column; }
  .left { flex:none; max-width:100%; padding:28px 24px; }
  .features { display:none; }
  .hero-title { font-size:24px; }
  .right { padding:32px 24px; }
}
</style>
